export default {"src":"/_next/static/image/public/images/ic_write_review.8d32b96c0a6dfb45cae5223e326b734f.svg","height":16,"width":19};